"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Jwt = void 0;
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const jwks_rsa_1 = __importDefault(require("jwks-rsa"));
class Jwt {
    constructor({ issuer, jwksUri }) {
        this.getSigningKey = async (token) => new Promise((res, rej) => {
            const decoded = jsonwebtoken_1.default.decode(token, { complete: true });
            const kid = decoded && decoded.header.kid;
            this.jwks.getSigningKey(kid, (err, key) => {
                if (err)
                    rej(err);
                else
                    res(key.getPublicKey());
            });
        });
        this.decode = async (token, options) => {
            const signingKey = await this.getSigningKey(token);
            return jsonwebtoken_1.default.verify(token, signingKey, {
                issuer: this.issuer,
                ...options,
            });
        };
        this.issuer = issuer;
        this.jwks = jwks_rsa_1.default({ jwksUri, strictSsl: false });
    }
}
exports.Jwt = Jwt;
//# sourceMappingURL=jwt.js.map